var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8994 10.4999V15.1666M6.00814 17.733C4.94713 19.5707 4.41678 20.4899 4.49603 21.2439C4.56515 21.9016 4.91032 22.4991 5.44531 22.8878C6.05846 23.3332 7.1188 23.3332 9.23937 23.3332H20.5595C22.68 23.3332 23.7402 23.3332 24.3534 22.8878C24.8883 22.4991 25.2337 21.9016 25.3028 21.2439C25.382 20.4899 24.8519 19.5707 23.7908 17.733L18.1328 7.93301C17.0718 6.0953 16.5411 5.1766 15.8485 4.86823C15.2444 4.59926 14.5541 4.59926 13.95 4.86823C13.2577 5.17647 12.7272 6.09517 11.6671 7.93136L6.00814 17.733ZM14.9587 18.6666V18.7832L14.8413 18.7835V18.6666H14.9587Z",
    stroke: "#AF976E",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorStatus);
export default __webpack_public_path__ + "static/media/error_status.5e1730bcadf43afea21ca0a65de4d4b5.svg";
export { ForwardRef as ReactComponent };